import { Button, IconButton, Tooltip } from "@mui/material";
import DirectionsIcon from "@mui/icons-material/Directions";

/** Link a Google Maps con le indicazioni stradali verso l'indirizzo (sul telefono apre l'app di navigazione) */
export function directionsUrl(address: string): string {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
}

interface Props {
    address?: string | null;
    /** "button" con etichetta, "icon" compatto */
    variant?: "button" | "icon";
    /** colore del testo/icona (es. "inherit" su sfondi colorati) */
    color?: "primary" | "inherit";
}

/** Pulsante "Portami lì": apre Google Maps con il percorso verso la palestra */
export default function MapsButton({ address, variant = "button", color = "primary" }: Props) {
    if (!address || !address.trim()) return null;
    const href = directionsUrl(address.trim());

    if (variant === "icon") {
        return (
            <Tooltip title="Apri in Google Maps">
                <IconButton size="small" color={color} href={href} target="_blank" rel="noopener noreferrer"
                    aria-label="Apri il percorso in Google Maps">
                    <DirectionsIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        );
    }
    return (
        <Button variant="outlined" color={color} startIcon={<DirectionsIcon />}
            href={href} target="_blank" rel="noopener noreferrer" sx={{ whiteSpace: "nowrap", flexShrink: 0 }}>
            Portami lì
        </Button>
    );
}
